module.exports = __webpack_public_path__ + "assets/img/7.aeb2f769.png";